module.exports = __webpack_public_path__ + "static/img/Rejuvenation-3.d4ca969.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/Rejuvenation-3.png
// module id = ecO/
// module chunks = 1